var serverActions = {
  loadClientResources : 'get_client_resources',
  loadCurrentUserResources : 'get_my_resources',
  loginToResource: 'open_client_to_resource_session',
  systemStatus: 'systemstatus',
  shareResource: 'share_resource',
  getSharedResources: 'get_my_shared_resources',
  confirmSharedResource: 'confirm_shared_resource',
  addNoteToResource: 'add_note_to_shared_resource',
  getNoteToResource: 'get_note_to_shared_resource',
  removeResource: 'remove_resource',
  changeResourceSettigns: 'change_resource_settings'
};

var serverErrors = {
  noResources: 'no_resources',
  noObjectsFound: 'no_objects_found'
}

var commonServerErrorResponses;
var commonServerSuccessResponses;
var localStorage;

var serverConnectorService;
var loginService;
var q;
var instance;
var currentResourceWebsocket;
var rootScope;
var roles

class ResourceService {
    constructor($q, ServerConnectorService, COMMON_SERVER_SUCCESS_RESPONSES, COMMON_SERVER_ERROR_RESPONSES, $localStorage, $rootScope, LoginService, ROLES) {
      instance = this;
      localStorage = $localStorage;
      rootScope = $rootScope;
      q = $q;
      serverConnectorService = ServerConnectorService;
      loginService = LoginService;
      commonServerSuccessResponses = COMMON_SERVER_SUCCESS_RESPONSES;
      commonServerErrorResponses  = COMMON_SERVER_ERROR_RESPONSES;
      roles = ROLES;
      this.loadCurrentUserResources = this.loadCurrentUserResources.bind(this);
      this.login = this.login.bind(this);
      this.getUserResource = this.getUserResource.bind(this);
      this.getInstalatorNoteToResource = this.getInstalatorNoteToResource.bind(this);
      this.getClientNoteToResource = this.getClientNoteToResource.bind(this);
    }
    
    loadCurrentUserResources(email){
      var deferred = q.defer();
      
      var request = {
        action_name : serverActions.loadCurrentUserResources,
        email : email
      }

      var websocket = loginService.getCurrentUserWebsocket();
      var onMessage = function(data){
        deferred.resolve({
          resources: instance.parseResources(data)
        })
      }
      var onError = function(error){
        if(error == serverErrors.noResources){
          deferred.resolve({
            resources: []
          });
        } else {
          deferred.reject(error);
        }
      }
      serverConnectorService.send(request, websocket, deferred, onMessage, onError);
      return deferred.promise;
    }

    login(currentUserLogin, resource) {
      var deferred = q.defer();
      
      var websocket = serverConnectorService.connect();

      var request = {
          action_name : serverActions.loginToResource,
          email : currentUserLogin,
          unique_id : resource.uniqueId,
      }

      var onMessage = function(data){
        currentResourceWebsocket = websocket;
        localStorage.loggedUser.currentResourceCredentails = localStorage.loggedUser.currentResourceCredentails || {}; 
        localStorage.loggedUser.currentResourceCredentails.userLogin = currentUserLogin;
        localStorage.loggedUser.currentResourceCredentails.resource = resource;

        instance.setCurrentResource(resource);
        
        deferred.resolve();
      }

      serverConnectorService.send(request, websocket, deferred, onMessage);
      return deferred.promise;
    }

    systemStatus() {
      var deferred = q.defer();
      var request = {
        action_name : serverActions.systemStatus,
      };
      serverConnectorService.send(request, currentResourceWebsocket, deferred);
      return deferred.promise;
    }

    /**
     * 
     * @param {*} resource for resource 
     * @param {*} instalatorLicenseId instalator license id
     * @param {*} hours - time in hourse when resource is availible for instalator
     */
    shareResourceForInstalator(resource, instalatorLicenseId, hours){
      var deferred = q.defer();
      var websocket = loginService.getCurrentUserWebsocket();
      var request = {
        action_name : serverActions.shareResource,
        unique_id : resource.uniqueId,
        license_id : instalatorLicenseId,
        hours_number : hours.toString() // :)
      }

      serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    getSharedResources(){
      var deferred = q.defer();
      var websocket = loginService.getCurrentUserWebsocket();
      var request = {
        action_name : serverActions.getSharedResources,
      }

      var onMessage = function(data){
        deferred.resolve({
          resources: instance.parseSharedResources(data)
        })
      }
      var onError = function(error){
        if(error == serverErrors.noObjectsFound){
          rootScope.errors = null;
          deferred.resolve({
            resources: []
          });
        } else {
          deferred.reject(error);
        }
      }

      serverConnectorService.send(request, websocket, deferred, onMessage, onError);
      return deferred.promise;
    }

    activateResource(shareId, token){
      var deferred = q.defer();
      var websocket = loginService.getCurrentUserWebsocket();
      
      var request = {
        action_name : serverActions.confirmSharedResource,
        share_id : shareId,
        token : token
      }

      serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    addNoteToResource(shareId, note){
      var deferred = q.defer();
      var websocket = loginService.getCurrentUserWebsocket();
      
      var request = {
        action_name : serverActions.addNoteToResource,
        share_id : shareId,
        note : note
      }

      serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    getInstalatorNoteToResource(shareId){
      return this.getNoteToResource(shareId, 'engineer'); 
    }

    getClientNoteToResource(shareId){
      return this.getNoteToResource(shareId, 'client'); 
    }

    getNoteToResource(shareId, role){
      var deferred = q.defer();
      var websocket = loginService.getCurrentUserWebsocket();
      
      var request = {
        action_name : serverActions.getNoteToResource,
        share_id : shareId,
        author :  role
      }

      serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    parseResources(data){
      var index = 0;
      var resources = [];
      while(true){
        if(!data['unique_id_' + index]){
          return resources;
        }

        resources.push({
          uniqueId: data['unique_id_' + index],
          avatarId: data['avatar_id_' + index],
          name: data['friendly_name_' + index],
          resourceType: data['resource_type_' + index]
        });

        ++index;
      }
    }

    parseSharedResources(data){
      var index = 0;
      var resources = [];
      while(true){
        if(!data['share_id_' + index]){
          return resources;
        }

        resources.push({
          clientEmail: data['client_email_' + index],
          licenseId: data['license_id_' + index],
          shareId: data['share_id_' + index],
          sharedFromTime: data['shared_from_time_' + index],
          sharedToTime: data['shared_to_time_' + index],
          confirmed: data['confirmed_' + index],
          token: data['token_' + index]
        });

        ++index;
      }
    }

    removeResource(uniqueId) {
      var deferred = q.defer();
      var websocket = loginService.getCurrentUserWebsocket();
      
      var request = {
        action_name : serverActions.removeResource,
        unique_id : uniqueId,
      }

      serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    changeResourceSettigns(uniqueId, settings) {
      var deferred = q.defer();
      var websocket = loginService.getCurrentUserWebsocket();
      
      var request = {
        action_name  : serverActions.changeResourceSettigns,
        unique_id : uniqueId,
        avatar_id : 'test', // FIXME pass as param
        friendly_name : settings.name
      }

      serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    close(){
      if(currentResourceWebsocket){
        currentResourceWebsocket.close();
        currentResourceWebsocket = null;
      }
    }

    setCurrentResource(resource){
      localStorage.loggedUser.currentResource = resource;
      rootScope.auth.currentResource = resource;
    }

    getCurrentResource(){
      return rootScope.auth.currentResource;
    }

    getUserResource(uniqueId){
      var result;
      console.log('this.getCurrentUserResources()', this.getCurrentUserResources());
      angular.forEach(this.getCurrentUserResources(), function(resource) {
        if(resource.uniqueId == uniqueId){
          result = resource;
        }
      });

      return result;
    }

    setCurrentUserResources(resources){
      localStorage.loggedUser.resources = resources;
      rootScope.auth.resources = resources;
    }

    getCurrentUserResources(){
      return rootScope.auth.resources;
    }

    getCurrentResourceWebsocket() {
      return currentResourceWebsocket
    }

    static factory($q, ServerConnectorService, COMMON_SERVER_SUCCESS_RESPONSES, COMMON_SERVER_ERROR_RESPONSES, $localStorage, $rootScope, LoginService, ROLES){
        return new ResourceService($q, ServerConnectorService, COMMON_SERVER_SUCCESS_RESPONSES, COMMON_SERVER_ERROR_RESPONSES, $localStorage, $rootScope, LoginService, ROLES);
    }
}

ResourceService.factory.$inject = ['$q', 'ServerConnectorService', 'COMMON_SERVER_SUCCESS_RESPONSES', 'COMMON_SERVER_ERROR_RESPONSES', '$localStorage', '$rootScope', 'LoginService', 'ROLES'];

export default ResourceService = ResourceService.factory;


// WEBPACK FOOTER //
// ./src/service/server-connector/resource.service.js